var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.expireTime)?_c('div',[_vm._v(" "+_vm._s(_vm.reservationText)+" "),_c('v-progress-linear',{attrs:{"value":_vm.progressValue,"color":_vm.progressColor}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }